// "Let NoVA pitch it" — opens the dock and asks for the pitch, whole story
// or one part (`focus` is a pitch node id: platform, app-kit, pricing …).
// The films beside it are the passive version of the same story; this is
// the one the visitor can interrupt. [[nova-pitch]]
import React from 'react';
import { askNova } from './ConsoleHeader';

const ASK = {
  '': 'Pitch nventr to me — the platform, App Kit and the modules. I will interrupt with questions.',
  platform: 'Pitch the nventr Platform to me, starting with Platform. I will interrupt with questions.',
  'app-kit': 'Pitch App Kit to me, starting with App Kit. I will interrupt with questions.',
  pricing: 'Walk me through nventr pricing, starting with Pricing.',
  gate: 'Pitch me what a gate is, starting with the gate.',
  'training-center': 'Pitch me the Neural Net Training Center, starting with the Training Center. I will interrupt with questions.',
  'bring-your-app': 'Pitch me bringing our existing app onto nventr, starting with bring your app. I will interrupt with questions.',
  start: 'Pitch me how we would start with nventr, starting with where to begin — map, optimize, build, track. I will interrupt with questions.',
};

export default function PitchButton({ focus = '', label = 'Let NoVA pitch it', className = '', hint = '' }) {
  const text = ASK[focus] || `Pitch nventr to me, starting with ${String(focus).replace(/-/g, ' ')}. I will interrupt with questions.`;
  return (
    <p className={`cs-pitch-cta ${className}`.trim()}>
      <button type="button" className="cs-btn cs-btn-outline cs-btn-sm" onClick={() => askNova(text)} data-nova-note="Starts NoVA's spoken pitch; the visitor can interrupt">
        ◈ {label}
      </button>
      {hint && <span className="cs-pitch-cta-hint">{hint}</span>}
    </p>
  );
}
